<template>
  <div style="min-height: 80vh">
    <div v-if="content">
      <a-row type="flex" class="articleLog" :class="{ justifyC: !isShow }">
        <a-col :span="isShow ? 20 : 14" style="z-index: 999">
          <div></div>
          <!-- --------quickprovisioning  页面独有 -->
          <div class="breadcrumbBox" v-show="!isShow">
            <!-- 面包屑 -->
            <a-breadcrumb>
              <a-breadcrumb-item>
                <i
                  class="iconfont icon-menu-home"
                  style="color: #41BC4C; margin-right: 5px"
                ></i>
                <a :href="homeHref" class="hoverColor" style="color: #41BC4C"
                  >Help Center</a
                ></a-breadcrumb-item
              >
              <a-breadcrumb-item>
                <span style="color: #41BC4C">Quick Start Guide</span>
              </a-breadcrumb-item>
            </a-breadcrumb>
          </div>
          <!-- --------quickprovisioning  页面独有 -->

          <div class="Titlebox">
            <h1>{{ title || articleTitle }}</h1>
            <p>update time：{{ articleTime }}</p>
          </div>
          <div>
            <viewer>
              <div
                style="display: flex; align-items: center; justify-content: center; margin-bottom: 16px;"
                v-html="iframeContent"
                v-if="iframeContent"
              ></div>
              <v-md-preview
                :text="content"
                ref="preview"
                class="mdview"
              ></v-md-preview
            ></viewer>
            <!-- <FeedbackModal
      
      :articleId="id"
      :articleTitle="articleTitle || title"
    
     
    /> -->
          </div>

          <!-- <div class="sharebox">
            分享本文：<share :config="config" style="display: inline"></share>
          </div> -->
        </a-col>
        <a-col :span="4">
          <div class="anchorBox">
            <p v-if="h3list[0]">directory</p>
            <a-anchor :affix="false" :target-offset="targetOffset">
              <div
                v-for="(h, index) in h3list"
                :key="index"
                @click="handleAnchor(h)"
              >
                <a-anchor-link :title="h.innerText" />
              </div>
            </a-anchor>
          </div>
        </a-col>
      </a-row>
      <!-- 900px以内不显示本文目录 -->
      <a-row type="flex" class="articleLog900">
        <a-col style="z-index: 999">
          <div class="Titlebox">
            <h1>{{ title || articleTitle }}</h1>
            <p>update time：{{ articleTime }}</p>
          </div>
          <viewer>
            <v-md-preview :text="content" class="mdview"></v-md-preview>
            </viewer
          >
          <!-- <div class="sharebox">
            分享本文：<share :config="config" style="display: inline"></share>
          </div> -->
        </a-col>
      </a-row>
    </div>
    <div v-else>
      <div v-if="loadding" style="margin: 15% auto; text-align: center">
        Loading……
      </div>
      <NoData v-else />
    </div>
  </div>
</template>
<script></script>
<script>
import NoData from "@/views/noData.vue";
import { articles, getJSON } from "@/utils/query.js";
import { getNowDate } from "@/utils/tool.js";
// import FeedbackModal from "@/views/FeedbackModal.vue";
export default {
  components: { NoData },
  props: {
    id: {},
    title: {},
    isShow: {
      default: true,
    },
  },
  data() {
    return {
      targetOffset: window.innerHeight / 4,
      loadding: false,
      h3list: [],
      imglist: [],
      articleTime: "",
      content: "",
      showArticle: false,
      isshow: "",
      config: {
        // url: "", // 网址，默认使用 window.location.href
        source: "", // 来源（QQ空间会用到）, 默认读取head标签：<meta name="site" content="http://overtrue" />
        title: "", // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
        description: "", // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
        image: "", // 图片, 默认取网页中第一个img标签
        sites: ["weibo", "wechat", "qq", "qzone"], // 启用的站点
        // disabled: ["google", "facebook", "twitter"], // 禁用的站点
        wechatQrcodeTitle: "微信扫一扫：分享", // 微信二维码提示文字
        wechatQrcodeHelper:
          "<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>",
      },
      iframeContent: "",
    };
  },
  computed: {
    isIsp() {
      return sessionStorage.getItem("isIsp") === "true";
    },

    homeHref() {
      return "/help/";
    },
  },
  watch: {
    id(value) {
      this.content = "";
      this.getArticles(value);
    },
    content() {
      document.documentElement.scrollTop = 0;
      this.onAddUrl();
    },
  },
  mounted() {
    this.getArticles(this.id);
  },
  methods: {
    onAddUrl() {
      this.$nextTick(function() {
        let _aList = this.$refs.preview.$el.querySelectorAll(
          "h1,h2,h3,h4,h5,h6"
        );
        let list = [];
        for (let i = 0; i < _aList.length; i++) {
          let _a = _aList[i];
          console.log(_a);
          let id = _a.getAttribute("data-v-md-line");
          if (!id) continue; // 把不属于导航中的a标签去掉，否则会报错
          _a.id = id; //锚点
          _a.xx = id; //锚点
          list.push(_a);
        }
        this.h3list = list;
        console.log("%O", this.$refs.preview.$el);
      });
    },
    async getArticles(id) {
      if (!id) return;
      this.loadding = true;
      let res = await articles(id);
      let { code, data } = res;
      if (code == "200" && data) {
        let { content, title, updateTime } = res.data;
        this.articleTitle = title;
        this.$emit("setarticleTitle", title);
        this.articleTime = getNowDate(updateTime);
        this.getContent(content);
      } else {
        this.loadding = false;
      }
      // 发送诸葛io埋点数据
      // 查一个文章 全局计数count 加一
      this.GLOBAL.count++;
      this.sentzhugePoint(id);
    },
    async getContent(contentUrl) {
      this.iframeContent = "";
      let json = await getJSON(contentUrl);
      this.content = json ? json : "";
      // 提取第一个 <iframe ...>...</iframe> 字符串
      const iframeMatch = this.content.match(/<iframe[\s\S]*?<\/iframe>/i);
      let iframeContent = iframeMatch ? iframeMatch[0] : "";


      this.iframeContent = iframeContent;
      // 移除所有 <iframe ...></iframe> 标签（包括YouTube等嵌入视频）
      this.content = this.content.replace(/<iframe[\s\S]*?<\/iframe>/gi, "");
      this.loadding = false;
    },
    sentzhugePoint(articleid) {
      let articleTitle = this.title || this.articleTitle;
      // this.zhugePoint("lysora-help-文档中心-文章统计", {
      //   userid: this.GLOBAL.userid, //用户id
      //   articleid, //文章id
      //   articleTitle, //文章标题
      // });
      console.log("lysora-help-文档中心-文章统计", articleTitle);
    },
    handleAnchor(anchor) {
      console.log(anchor);
      const { preview } = this.$refs;
      const heading = anchor;

      // const heading = preview.$el.querySelector(`[data-v-md-line="${lineIndex}"]`);

      if (heading) {
        // 注意：如果你使用的是编辑组件的预览模式,则这里的方法名改为 previewScrollToTarget
        preview.scrollToTarget({
          target: heading,
          scrollContainer: window,
          top: 60,
        });
      }
    },
  },
};
</script>
<style scoped>
/* @media screen and (max-width: 900px) {
  .articleLog {
    display: none !important;
  }
} */
/* <!-- 900px以上显示本文目录 --> */
@media screen and (min-width: 901px) {
  .articleLog900 {
    display: none !important;
  }
}
.editor {
  z-index: -1;
  border: none;
  padding: 0;
}
.editor::v-deep .v-show-content {
  padding: 0;
}
.displayNone {
  display: none;
}
.navigation-content {
  display: none;
}
.anchorBox {
  width: 20vw;

  padding-left: 2rem;
  position: fixed;
}
.anchorBox::v-deep .ant-anchor-link-active {
  border-left: 2px solid #41BC4C;
}
.anchorBox::v-deep .ant-anchor-link-active .ant-anchor-link-title {
 color: #41BC4C;
}
.anchorBox::v-deep .ant-anchor-link-title:hover{
  color: #41BC4C;
}
.anchorBox::v-deep .ant-anchor-wrapper {
  height: 70vh;
  overflow-y: auto;
}
.sharebox {
  text-align: center;
  padding: 1rem;
  border-top: 1px solid #eaf1ff;
  border-bottom: 1px solid #eaf1ff;
}

.Titlebox {
  padding: 0 1rem;
  /* overflow: auto; */
}
.Titlebox h1 {
  font-size: 2rem;
  font-weight: 500;
}
.Titlebox p {
  padding-bottom: 0.5rem;
  /* border-bottom: 1px solid #eaf1ff; */
}
.justifyC {
  justify-content: center;
}
.mdview::v-deep .github-markdown-body {
  padding: 0 1rem;
}

.ant-anchor-wrapper::-webkit-scrollbar {
  width: 5px;
}
.ant-anchor-wrapper::-webkit-scrollbar-track {
  background: rgb(235, 234, 234);
  border-radius: 5px;
}
.ant-anchor-wrapper::-webkit-scrollbar-thumb {
  background: rgb(199, 199, 199);
  border-radius: 5px;
}
.ant-anchor-wrapper::-webkit-scrollbar-thumb:hover {
  background: rgb(199, 199, 199);
  border-radius: 5px;
}
.anchorBox::-webkit-scrollbar-thumb:active {
  background: rgb(141, 141, 141);
  border-radius: 5px;
}
.breadcrumbBox {
  padding: 1rem;
}
.breadcrumbBox::v-deep .ant-breadcrumb > span:last-child {
  color: rgba(0, 0, 0, 0.45);
}
</style>
